import Store from "@/store";
import axios from "axios";

export default {
    path: '/payment',
    name: 'AppPayment',
    component: () => import('@/views/payment/index.vue'),
    meta: {
        title: 'Выбор оплаты',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {

        let entry = false;
        let main = false;
        let text = false;

        if(Store.getters['entry_video/entry'].length > 0) {
            entry = true
        }

        await Store.getters['main_videos/main'].forEach(item => {

            if (item.control === 'main') {
                main = true
            }

            if(item.type === 'text') {
                text = true
            }

        })

        let token = Store.getters['auth/token']


        if(entry && main && text) {
            if(token) {
                let checkToken = await axios.post('/checkTocken', {
                    tocken: token
                })

                if(checkToken.data) {
                    next()
                } else {
                    next({name: 'Auth'})
                }
            } else {
                next({name: 'Auth'})
            }
            next()
        } else {
            next({name: 'Theme'})
        }
    }
}